module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    " + _vm._s(_vm.resultsLengthText) + " found for \"\n    "), _c('b', [_vm._v(_vm._s(_vm.searchMessage.toUpperCase()))]), _vm._v("\"\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings",
    attrs: {
      "id": "results"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedNotes), function(note, index) {
    return _c('tr', {
      key: (index + "-note-" + (note.noteId))
    }, [_c('td', [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.cusip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToAccountDetail(note)
        }
      }
    }, [_vm._v("Account details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToNoteDetails(note)
        }
      }
    }, [_vm._v("Note details")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Note number")]), _vm._v(" "), _c('th', [_vm._v("CUSIP number")]), _vm._v(" "), _c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c46462e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchByNoteNumberOrCUSIPResults.vue
// module id = 2201
// module chunks = 1